import Calendar from "@/utils/calendar";

export const columns = [
  {
    title: "#",
    dataIndex: "id",
    key: "id",
    width: 40,
    customRender: (text, record, index) => {
      return index + 1;
    },
  },
  {
    title: "辅料sku",
    dataIndex: "shopProductSku",
    key: "shopProductSku",
  },
  {
    title: "辅料名称",
    dataIndex: "productName",
    key: "productName",
  },
  {
    title: "店铺名称",
    dataIndex: "customerShopName",
    key: "customerShopName",
  },
  {
    title: "库存数",
    dataIndex: "totalChecked",
    key: "totalChecked",
  },
  {
    title: "操作",
    dataIndex: "id",
    key: "idAction",
    scopedSlots: {
      customRender: "action",
    },
  },
];

export const columnsOperationData = [
  {
    title: "#",
    dataIndex: "id",
    key: "id",
    width: 40,
    customRender: (text, record, index) => {
      return index + 1;
    },
  },
  {
    title: "时间",
    dataIndex: "lmt",
    key: "lmt",
  },
  {
    title: "商品订单编号",
    dataIndex: "bizeId",
    key: "bizeId",
  },
  {
    title: "当前库存",
    dataIndex: "checked",
    key: "checked",
  },
  {
    title: "库存变动数量",
    dataIndex: "change",
    key: "change",
    customRender: (text, record, index) => {
      let symbol = record.operationType < 2 ? "+" : "-";
      // return record.operationType<2?'+':'-' + record.stockAmount
      return symbol + record.stockAmount;
    },
  },
  {
    title: "剩余数",
    dataIndex: "num",
    key: "num",
    customRender: (text, record, index) => {
      if (record.operationType < 2) {
        return record.checked + record.stockAmount;
      } else {
        return record.checked - record.stockAmount;
      }
    },
  },
];
